import { render, staticRenderFns } from "./syncPatient.vue?vue&type=template&id=92f781ae&scoped=true"
import script from "./syncPatient.vue?vue&type=script&lang=js"
export * from "./syncPatient.vue?vue&type=script&lang=js"
import style0 from "./syncPatient.vue?vue&type=style&index=0&id=92f781ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f781ae",
  null
  
)

export default component.exports